import { BASE_RULES_KEY } from '../types'
import { defineNuxtPlugin, useCoreRules } from '#imports'

export default defineNuxtPlugin({
    name: 'rules',
    parallel: true,
    setup(nuxtApp) {
        const {
            required,
            email,
            minLength,
            password,
            passwordOld,
            between,
            noSpecialCharacters,
            noNumbers,

            EMAIL,
            NEW_PASSWORD,
            EXISTING_PASSWORD
        } = useCoreRules()

        nuxtApp.vueApp.provide(BASE_RULES_KEY, {
            required,
            email,
            minLength,
            password,
            passwordOld,
            between,
            noSpecialCharacters,
            noNumbers,

            EMAIL,
            NEW_PASSWORD,
            EXISTING_PASSWORD,
        })
    }
})
